import request from '@/utils/request'

// 获得所有活动
export function getAllActivityInfo() {
    return request({
        url: '/api/ActivityInfo/GetAllActivityInfo',
        method: 'get',
    })
}
// 活动详情
export function getActivityInfoById(id) {
    return request({
        url: '/api/ActivityInfo/Get',
        method: 'get',
        params: {id}
    })
}

// 活动报名
export function addActivityParticipants(params) {
    return request({
        url: '/api/ActivityInfo/AddActivityParticipants',
        method: 'post',
        data: params
    })
}

// 检查用户是否已报名
export function checkUserSignedUp(activityId, memberId) {
    return request({
        url: '/api/ActivityInfo/CheckUserSignedUp',
        method: 'get',
        params: { activityId, memberId }
    })
}

// 批量获取用户在多个活动中的报名状态
export function getUserSignedUpActivities(activityIds, memberId) {
    return request({
        url: '/api/ActivityInfo/GetUserSignedUpActivities',
        method: 'post',
        data: activityIds,
        params: { memberId }
    })
}

// 获取互选大厅参与者列表
export function getMutualChoiceMembers(activityId, memberId) {
    return request({
        url: '/api/ActivityInfo/GetMutualChoiceMembers',
        method: 'get',
        params: { activityId, memberId }
    })
}

// 提交互选意向
export function submitMutualChoice(params) {
    return request({
        url: '/api/ActivityInfo/SubmitMutualChoice',
        method: 'post',
        data: params
    })
}

// 活动签到
export function checkIn(params) {
    return request({
        url: '/api/ActivityInfo/CheckIn',
        method: 'post',
        data: params
    })
}

// 取消互选意向
export function cancelMutualChoice(params) {
    return request({
        url: '/api/ActivityInfo/CancelMutualChoice',
        method: 'post',
        data: params
    })
}

// 获取用户在当前活动中的心仪对象列表
export function getMyFavoriteMembers(activityId, memberId) {
    return request({
        url: '/api/ActivityInfo/GetMyFavoriteMembers',
        method: 'get',
        params: { activityId, memberId }
    })
}

// 获取用户跨活动的心仪对象列表
export function getAllMyFavoriteMembers(memberId) {
    return request({
        url: '/api/ActivityInfo/GetAllMyFavoriteMembers',
        method: 'get',
        params: { memberId }
    })
}

// 获取微信 JSSDK 签名配置
export function getWeChatJsSdkConfig(url) {
    return request({
        url: '/api/Wx/GetJsSdkConfig',
        method: 'get',
        params: { url }
    })
}

// 取消活动报名
export function cancelActivityParticipants(activityId, memberId) {
    return request({
        url: '/api/ActivityInfo/CancelActivityParticipants',
        method: 'post',
        params: { activityId, memberId }
    })
}


// 获取活动签到列表（红娘端）
export function getActivityParticipantsList(data) {
  return request({
    url: "/api/ActivityInfo/GetWithdrawMemberInfoListByPage",
    method: "post",
    data
  });
}

// 获取活动互选记录（红娘端）
export function getMutualChoiceRecords(activityId) {
  return request({
    url: "/api/ActivityInfo/GetMutualChoiceRecords",
    method: "get",
    params: { activityId }
  });
}


// WEBPACK FOOTER //
// ./src/api/activityInfo.js